<template>
  <div class>
    <AppHeader />
    <section>
      <div class="container">
        <div class="top-bar">
          <button class="button is-primary" @click.prevent="back">
            <span class="icon">
              <i class="fas fa-angle-left" />
            </span>
            <span>Back to Account</span>
          </button>
        </div>
        <cnc-query
          class="mb-6"
          :query="didInfoQuery.query"
          :vars="didInfoQuery.vars"
          :key="JSON.stringify(didInfoQuery.vars)"
        >
          <template v-slot="{ model }">
            <h1 class="title">{{ didNumberId }} - {{ model.name }}</h1>
            <p class="owner-bar">
              Owner:
              <span>
                <i class="fas fa-user"></i>
                {{ model.account.firstName }} {{ model.account.lastName }}
              </span>
              <span>
                <i class="fas fa-hashtag"></i>
                {{ accountId }}
              </span>
            </p>
            <h2 class="title is-4">PSTN Mappings</h2>
          </template>
        </cnc-query>
        <cnc-schema-list
          schema="PSTNMapping"
          emptyMessage="No PSTN mapping have been registered yet."
          :columnLabels="{
            mapToId: 'Map To',
            startTime: 'Start Time',
            endTime: 'End Time',
          }"
          :fieldLabels="{
            mapToId: 'Map To',
            startTime: 'Start Time',
            endTime: 'End Time',
          }"
          :config="config"
          :sort="[{ path: 'id', direction: 'ASCENDING' }]"
        />
      </div>
    </section>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "../components/AppHeader";
import AppFooter from "../components/AppFooter";

export default {
  name: "home",
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      config: {
        fields: {
          mapToId: {
            label: "Map To",
            suggestions: async (filter) => {
              const extensions = await this.$cnc.load({
                query: `query {
          models:AccountMany {
             id
             firstName
             company
          }
        }`,
              });
              const extensionsIds = extensions.models
                .map((extension) => {
                  return {
                    label: `${extension.id} - ${
                      extension.firstName || extension.company
                    }`,
                    value: extension.id,
                    type: "Extension",
                  };
                })
                .filter((s) =>
                  s.label.toLowerCase().includes(filter.toLowerCase())
                );

              const ivrs = await this.$cnc.load({
                query: `query {
          models:IVRMany{
            id
            name
          }
        }`,
              });

              const ivrIds = ivrs.models

                .map((ivr) => {
                  return {
                    label: `${ivr.id} - ${ivr.name}`,
                    value: ivr.id,
                    type: "IVR",
                  };
                })
                .filter((s) =>
                  s.label.toLowerCase().includes(filter.toLowerCase())
                );
              const suggestions = [...extensionsIds, ...ivrIds];
              return suggestions;
            },
          },
        },
      },
      models: {
        type: Object,
        default: () => ({}),
      },
    };
  },
  computed: {
    accountId() {
      return this.$route.params.accountId;
    },
    didNumberId() {
      return this.$route.params.didNumberId;
    },
    didInfoQuery() {
      return {
        query: `query($id: ID!) { 
          model: DidNumberOne(id: $id ) {
            name
            account {
              firstName
              lastName
            }
          }
        }`,
        vars: { id: this.didNumberId },
      };
    },
  },
  methods: {
    back() {
      this.$router.replace({
        name: "Account-update",
        params: { accountId: this.$route.params.accountId },
      });
    },
  },
};
</script>

<style scoped>
.top-bar,
.owner-bar {
  margin-bottom: 2em;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
